var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEraser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 38,
    viewBox: "0 0 30 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6782_28972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.22541 11.1446L9.76124 4.80032C10.8629 2.83144 12.2885 -1.00749 15.0308 0.246576C17.3754 1.31873 19.6712 2.46521 22.0236 3.53448C23.641 4.26994 25.0743 4.70341 25.8858 6.37234C26.3864 8.54307 28.0047 12.6719 28.2147 14.5612C27.6217 16.1231 26.2364 18.508 25.4057 20.0725C24.8318 21.1552 23.7514 23.3032 23.1188 24.2798C22.2033 26.2169 21.0836 28.149 20.0616 30.0403C19.0132 31.9802 18.0016 33.998 16.7674 35.8204C16.04 36.8677 14.9001 37.0863 13.7074 36.9689C12.4271 36.5766 9.8562 35.1734 8.62225 34.5189C6.22853 33.2493 2.9311 31.9302 0.921042 30.1837C-0.371014 29.061 0.0623579 24.6391 0.0986118 22.9595C0.185525 21.3275 5.05808 13.2511 6.22541 11.1446Z",
    fill: "#FC513D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22656 11.1446L9.7624 4.80032C10.8641 2.83144 12.2896 -1.00749 15.0319 0.246576C17.3766 1.31873 19.6723 2.46521 22.0248 3.53448C23.6421 4.26994 25.0755 4.70341 25.887 6.37234C26.3876 8.54307 28.0058 12.6719 28.2159 14.5613C27.6229 16.1231 26.2375 18.508 25.4068 20.0725C24.833 21.1552 23.7526 23.3032 23.1199 24.2798C22.3279 22.8752 21.3093 18.4641 20.4494 17.508L20.425 17.4217C15.9107 15.2747 10.8403 13.1224 6.22656 11.1446Z",
    fill: "#9FDCD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8858 6.37305C26.3864 8.54377 28.0046 12.6726 28.2147 14.562C27.6217 16.1238 26.2363 18.5087 25.4056 20.0732C24.8318 21.1559 23.7514 23.3039 23.1187 24.2805C22.3267 22.8759 21.3081 18.4648 20.4482 17.5087L20.4238 17.4224C20.6404 17.1145 21.3817 15.7595 21.5265 15.3954C22.4789 13.0001 25.5989 8.78596 25.8858 6.37305Z",
    fill: "#74AE9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.448 17.5098C21.3079 18.4658 22.3265 22.8769 23.1186 24.2815C22.2031 26.2186 21.0834 28.1507 20.0613 30.042C19.013 31.982 18.0013 33.9997 16.7672 35.8221C16.0398 36.8694 14.8998 37.0881 13.7072 36.9706C14.0056 36.888 14.0109 36.886 14.2792 36.7318C14.4378 35.5977 12.5708 31.6727 12.604 29.3227C13.0518 29.2433 13.4838 29.1086 13.9206 28.9823C15.0387 27.8138 15.5516 26.4248 16.3475 25.0674C17.709 22.7453 19.0394 19.75 20.448 17.5098Z",
    fill: "#DC2E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0986118 22.9609C1.30436 24.6159 5.64822 26.1217 7.49249 27.1776C8.3884 27.6906 11.675 29.2934 12.6042 29.3224C12.571 31.6724 14.438 35.5974 14.2794 36.7316C14.0111 36.8857 14.0058 36.8878 13.7074 36.9704C12.4271 36.5781 9.8562 35.1749 8.62225 34.5204C6.22853 33.2508 2.9311 31.9317 0.921042 30.1852C-0.371014 29.0625 0.0623579 24.6406 0.0986118 22.9609Z",
    fill: "#ED3727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6782_28972",
    x: 0,
    y: 0,
    width: 29.2168,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6782_28972"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6782_28972",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.12276e9180e8c4804dc8a1dcb5fcb4bd.svg";
export { ForwardRef as ReactComponent };